exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".password-form[data-v-a8bc34e8] {\n  border: 1px solid #f56c6c;\n  padding: 5px;\n  -webkit-box-shadow: 0 0 2px 2px rgba(245, 108, 108, 0.7);\n          box-shadow: 0 0 2px 2px rgba(245, 108, 108, 0.7);\n}", ""]);

// exports
